module.exports = __webpack_public_path__ + "img/logo.68e578d8.svg";